import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

// components
import CheckboxRadio from 'common/CheckboxRadio';
import HtmlText from 'html-text/HtmlText';
import { Link, TooltipWrapper } from '@tcc/crate';
import { dateFormatter } from '@tcc/i18n';
import { getMessage } from 'util/locale';

const baseString = 'vra-fertility-activity-categories';
const classString = classNames({
  [`${baseString}`]: true
});
const FertilityActivityCategories = ({
  disabled,
  fertilityActivities,
  fertilityActivityCategories,
  onSelectFertilityActivityCategory,
  plantingPlanParams
}) => {
  const activityCategories = fertilityActivityCategories.map(({ activityType, activityCategoryUuid, code }) => {
    const existingActivity = get(fertilityActivities, activityType, {});
    const { date } = existingActivity;
    const formattedDate = dateFormatter(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    return (
      <li key={activityType}>
        <CheckboxRadio
          dataTestId={`${baseString}-${code}`}
          disabled={disabled}
          isChecked={activityCategoryUuid === plantingPlanParams.activityCategoryUuid}
          labelText={getMessage(`label-text__activity--fertility-${code}`)}
          name='fertility-activity-categories'
          onChange={() => onSelectFertilityActivityCategory(activityCategoryUuid)}
          type='radio'
        />
        { date && <small>{formattedDate}</small> }
      </li>
    );
  });

  return (
    <section className={classString}>
      <header >{getMessage('title-text__activity-category')}</header>
      <p><HtmlText messageKey='text__activity-category-intro' /></p>
      <TooltipWrapper
        content={[getMessage('tooltip-text__fertility-activities')]}
        placement='bottom'>
        <Link data-test-id={`${baseString}-more-info`}>
          {getMessage('button-text__more-information')}
        </Link>
      </TooltipWrapper>
      <ul>
        {activityCategories}
      </ul>
    </section>
  );
};
FertilityActivityCategories.propTypes = {
  disabled: propTypes.bool,
  fertilityActivities: propTypes.object.isRequired,
  fertilityActivityCategories: propTypes.array.isRequired,
  onSelectFertilityActivityCategory: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired
};
export default FertilityActivityCategories;
